@if (node() && formGroup()) {
  <div class="client-panel">
    <form class="client-form" [formGroup]="formGroup()!" (ngSubmit)="onSubmit()">
      <div class="header">
        <ul class="tabs">
          @for (tab of tabs; track tab.caption) {
            <li class="tab" [hidden]="tab.hidden">
              <a class="tab-link" [ngClass]="{'active': tabSelected === tab}">{{tab.caption}}</a>
            </li>
          }
        </ul>
      </div>
      <div class="body">
        <div class="row">
          <div class="content-field">
            <app-text [formGroup]="formGroup()!" [meta]="metaId" [model]="node()!.clientId"></app-text>
          </div>
        </div>
        <div class="row">
          <div class="content-field">
            <app-text [formGroup]="formGroup()!" [meta]="metaSecret" [model]="node()!.secret"></app-text>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="row">
          <button type="submit" class="button button-big" [disabled]="disabled">
            <mat-icon class="regular-icon">save</mat-icon>
          </button>
        </div>
      </div>
    </form>
  </div>
}
